// extracted by mini-css-extract-plugin
module.exports = {"subMenu":"SubMenu_subMenu__2BLeN","profile":"SubMenu_profile__2Pr3n","feedback":"SubMenu_feedback__1miA6","arrow":"SubMenu_arrow__1jBEC"};